export default __webpack_public_path__ + "static/media/faq-icon.1ce1151d.svg";